import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { VendorCreditItemsBus } from '@app/cp/shared/models/VendorCreditItemsBus';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { aggregateBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'vendor-credit-items',
    templateUrl: './vendor-credit-items.component.html',
    styleUrls: ['./vendor-credit-items.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VendorCreditItemsComponent extends BaseGridEditLineComponent<VendorCreditItemsBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "VendorCreditItemsBus";
  }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'vendorCreditItemId': new UntypedFormControl(),
            'vendorCreditId': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'quantity': new UntypedFormControl(),
            'cost': new UntypedFormControl(),
            'classId': new UntypedFormControl(),
            'qbid': new UntypedFormControl(),
            'qbeditSequenceId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'invDesc': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'pushedToInvoice': new UntypedFormControl(),
            'accountClassName': new UntypedFormControl(),
            'invNumber': new UntypedFormControl(),
            'dispatchNumber': new UntypedFormControl(),
            'orderNumber': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            vendorCreditItemId: this.selectedData.vendorCreditItemId,
            vendorCreditId: this.selectedData.vendorCreditId,
            inventoryId: this.selectedData.inventoryId,
            quantity: this.selectedData.quantity,
            cost: this.selectedData.cost,
            classId: this.selectedData.classId,
            qbid: this.selectedData.qbid,
            qbeditSequenceId: this.selectedData.qbeditSequenceId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            dispatchId: this.selectedData.dispatchId,
            invDesc: this.selectedData.invDesc,
            orderId: this.selectedData.orderId,
            pushedToInvoice: this.selectedData.pushedToInvoice,
            accountClassName: this.selectedData.accountClassName,
            invNumber: this.selectedData.invNumber,
            dispatchNumber: this.selectedData.dispatchNumber,
            orderNumber: this.selectedData.orderNumber
        });
    }
    dispatchSearch: boolean = false;

    customCellClick(col: ColumnComponent) {
        if (this.hasInvSvc) {
            if (col.field === 'dispatchNumber') {
                this.dispatchSearch = true;
            }
        }
    }

    costChange(event, dataItem, editForm) {

    }
    public accountClass(id: string) {
        return this.referenceData.accountClasses.find(x => x.value === id);
    }
    deletedLocalNoId() {
        this.setTotal();
        this.sendParentMessage(MessageType.changed);
    }

    totalAmount: number = 0;
    setTotal() {
        this.totalAmount = this.getTotal;
    }
    get getTotal(): number {
        let total: number = 0;
        if (this.hasGridData) {
            for (let item of this.gridData) {
                total += item.quantity * item.cost
            }
        }
        return CommonFunctions.RoundToPrecision(total, 2);
    }
    processGridData() {
        super.processGridData();
        this.setTotal();
    }
    protected afterSaveCurrent(data: VendorCreditItemsBus) {
        this.setTotal();
    }
}
